<template>
  <div class="layout medical-analyse-form">
    <u-confirm id="delete-doctype" ref="confirm" />
    <c-loader v-if="loading" label="" :active="loading" height="500" />

    <div v-else>
      <div class="layout-header">
        <div class="layout-title">
          {{ id ? "Редактирование анализа" : "Новый анализ" }}
        </div>
        <div class="layout-header-actions">
          <div v-if="id" class="layout-header-action medical-analyse-form-action">
            <c-button-2
              size="small"
              label="Удалить"
              :icon="{
                icon: 'trash',
                color: 'secondary',
              }"
              @click="deleteAnalyse"
            />
          </div>
          <div class="layout-header-action medical-analyse-form-action">
            <c-button-2
              size="small"
              label="К списку анализов"
              :icon="{
                icon: 'back',
                color: 'blue',
              }"
              @click="$router.push({ name: 'medical-analyses-list' })"
            />
          </div>
        </div>
      </div>
      <div>
        <div class="document-form__name">
          <c-input-2
            v-model="form.name"
            floating-label="Название анализа"
            :style="{
              'margin-bottom': submitted && nameError ? '40px' : '',
            }"
            :required-mark="true"
            :required="submitted && nameError"
            :required-message="submitted && nameError"
            :clearable="true"
            :max-length="255"
          />
        </div>
        <div class="document-form__type">
          <c-input-2
            v-model="form.type"
            floating-label="Тип анализа"
            type="select"
            :style="{
              'margin-bottom': submitted && analyseTypeError ? '40px' : '',
            }"
            :items="analysesTypes"
            :searchable="true"
            :required="submitted && analyseTypeError"
            :required-condition="submitted && analyseTypeError"
            :required-mark="true"
          />
        </div>
        <div class="document-form__name">
          <c-input-2
            v-model="form.posts"
            :type="'select'"
            :label="'Должности, для которых нужен анализ'"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-value="form.postsAllExcept"
            :checkbox-tooltip="{
              disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
              activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
              notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
            }"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="positions"
            @checkboxChange="filterPosts"
          />
        </div>
        <div class="document-form__name medical-form-expiring-days">
          <c-input-2
            v-model="form.expireInDays"
            :max-length="10"
            :input-text-condition="expireDaysWrongValue && 'Некорректное значение'"
            :style="{
              'margin-bottom': expireDaysWrongValue ? '20px' : '',
            }"
            label="Срок годности в днях"
            placeholder="0"
          />
          <span>дней</span>
        </div>
        <div class="document-form__name medical-comment-input">
          <c-input-2 v-model="form.comment" floating-label="Комментарий" :clearable="true" :max-length="500" />
        </div>
      </div>
      <div class="document-form__actions">
        <c-button-2 size="large" class="document-form__reset" label="Отменить" @click="reset" />
        <c-button-2
          class="document-form__save"
          label="Сохранить"
          color="primary"
          size="large"
          :disabled="pending"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Button2 from "@/components/controls2/Button";
import loader from "@/components/loader";
import Input2 from "@/components/controls2/Input";
import Confirm from "@/pages/documents/u-confirm";

const defaultAnalyze = {
  name: "",
  type: "",
  expireInDays: "",
  comment: "",
  posts: [],
  postsAllExcept: false,
};

export default {
  name: "medical-analyse-form",
  components: {
    "c-button-2": Button2,
    "c-loader": loader,
    "c-input-2": Input2,
    "u-confirm": Confirm,
  },
  data() {
    return {
      id: "",
      loading: true,
      submitted: false,
      pending: false,

      form: { ...defaultAnalyze },
      savedData: { ...defaultAnalyze },
    };
  },

  computed: {
    ...mapState("medicalAnalysesForm", ["analysesTypes", "positions"]),
    nameError() {
      return !this.form.name.trim().length ? "Обязательное поле" : "";
    },
    analyseTypeError() {
      return !this.form.type.value ? "Обязательное поле" : "";
    },
    expireDaysWrongValue() {
      const check = this.form.expireInDays / 1;
      return Number.isNaN(check) || check < 0;
    },
  },

  watch: {
    "form.posts": function (v) {
      if (!v.length) {
        this.form.postsAllExcept = false;
      }
    },
  },

  mounted() {
    //    alert("1");
    this.$store.dispatch("medicalAnalysesForm/fetchAnalysesTypes");
  },

  created() {
    this.$store.dispatch("medicalAnalysesForm/fetchPositions");

    const { id } = this.$route.params;
    this.id = id;

    if (id) {
      this.pending = true;
      this.$store.dispatch("medicalAnalysesForm/fetchAnalyseById", { id }).then((analyse) => {
        this.savedData = analyse;
        this.setData(this.savedData);
        this.loading = false;
        this.pending = false;
      });
      return;
    }

    this.loading = false;
  },
  beforeDestroy() {
    this.setData({ ...defaultAnalyze });
  },
  methods: {
    setData(data = {}) {
      this.form.name = data.name || "";
      this.form.expireInDays = data.expire_in_days || "";
      this.form.comment = data.comment || "";
      this.form.posts =
        data.posts.map((item) => ({
          label: item.name,
          value: item.code,
        })) || [];
      this.form.type = this.analysesTypes.find((type) => {
        if (type.value === +data.type_id) {
          return type;
        }
        return "";
      });
      this.form.postsAllExcept = data.posts_all_except || false;
    },
    validate() {
      if (this.nameError) {
        return false;
      }

      return !this.analyseTypeError;
    },
    reset() {
      this.setData({ ...this.savedData });
    },
    submit() {
      this.submitted = true;
      if (!this.validate()) return false;

      this.submitted = false;
      this.pending = true;

      if (this.id) {
        this.$store
          .dispatch("medicalAnalysesForm/updateAnalyse", {
            id: this.id,
            ...this.form,
          })
          .then(() => {
            this.$notify({
              group: "success-message",
              data: {
                textMessage: `Анализ <strong>${this.form.name}</strong> успешно изменён`,
              },
            });
            this.savedData = this.form;
            this.$router.push({ name: "medical-analyses-list" });
          })
          .finally(() => {
            this.pending = false;
          });

        return true;
      }

      this.$store
        .dispatch("medicalAnalysesForm/createAnalyse", { ...this.form })
        .then(({ success, model }) => {
          if (success) {
            this.$notify({
              group: "success-message",
              data: {
                textMessage: `Анализ <strong>${this.form.name}</strong> успешно сохранён`,
              },
            });
            this.savedData = this.form;
            this.id = model.id;
            this.$router.push({
              name: "edit-medical-analyse",
              params: { id: model.id },
            });
          }
        })
        .finally(() => {
          this.pending = false;
        });

      return true;
    },
    deleteAnalyse() {
      this.$refs.confirm.open(
        {
          title: "Удаление анализа",
          text: `Анализ <b>${this.savedData.name}</b> будет удалён без возможности восстановления`,
        },
        () => {
          this.$store.dispatch("medicalAnalyses/deleteAnalyse", this.savedData.id).then(() => {
            this.$router.push({ name: "medical-analyses-list" });
          });
        },
      );
    },
    filterPosts(value) {
      this.form.postsAllExcept = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.medical-form-expiring-days {
  display: flex;
  align-items: center;
}
.medical-form-expiring-days span {
  display: block;
  margin-left: 1rem;
  margin-top: 1rem;
}
.document-form__actions {
  margin-top: 0;
}
@media (max-width: 480px) {
  .layout {
    margin: 0;
  }
  .document-form {
    &__actions {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
    }
    &__actions button {
      width: 50%;
      margin: 0;
      border-radius: 0;
    }
    &__reset {
      background: #fff;
    }
  }
}
</style>

<style>
@media (max-width: 480px) {
  .medical-analyse-form-action .c-button {
    width: 30px;
    height: 30px;
  }
  .medical-analyse-form-action .c-button-icon {
    margin: 0 -4px !important;
  }
  .medical-analyse-form-action .c-button-label {
    display: none !important;
  }
  .medical-comment-input {
    margin-bottom: 80px;
  }
}
</style>
